<template>
  <div class="parent">
    <banner v-bind:bannerObj="bannerObj"></banner>
    <div class="contact">
      <img src="../assets/images/map.png" alt>
    </div>
    <footer>
      <footContent></footContent>
    </footer>
  </div>
</template>

<style lang="scss">
.parent {
  background-color: #fff;
  .contact {
    width: 1200px;
    margin: 40px auto;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>


<script>
import store from "../vuex";
import DetailBanner from "../components/DetailBanner";
import FootContent from "../components/FootContent.vue";

// import Child from '../components/Child.vue'
export default {
  data() {
    return {
      bannerObj: {
        imgUrl: require("../assets/images/contact.png"),
        text: "CONTACT"
      }
    };
  },
  components: {
    banner: DetailBanner,
    footContent: FootContent
  },
  store
};
</script>

